module.exports = __webpack_public_path__ + "static/img/cont503.a736479.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont503.jpg
// module id = w4D2
// module chunks = 0